import { LogLevelDesc } from 'loglevel'
import {
  isDev,
  isEuProd,
  isProduction,
  isStaging,
  isTesting,
} from '../Utils/environment'
import configData from './config.json'

export type Config = {
  supportEmail: string
  monitoring: {
    datadogRumApplicationId: string
    datadogRumClientToken: string
  }
  development: EnvDependentConfig
  testing: EnvDependentConfig
  staging: EnvDependentConfig
  production: EnvDependentConfig
  'eu-production': EnvDependentConfig
}

export type EnvDependentConfig = {
  name: string
  ntrceApiUrl: string
  gaMeasurementId?: string
  debugLevel: LogLevelDesc
  featureFlags?: { [key: string]: boolean }
  hotjar?: {
    hjid: number
    hjsv: number
    debug: boolean
    trustero_users: boolean
  }
  monitoring?: {
    datadog?: {
      clientToken: string
      forwardErrorsToLogs: boolean
      sampleRate: number
      // Datadog site (e.g. 'datadoghq.eu') + RUM app/token for orgs hosted
      // outside the default US1 site. Falls back to AppConfig.monitoring when unset.
      site?: string
      rumApplicationId?: string
      rumClientToken?: string
    }
  }
}

export const AppConfig = configData as Config
export const EnvConfig = ((): EnvDependentConfig => {
  const { development, testing, staging, production } = AppConfig
  const euProduction = AppConfig['eu-production']
  if (isDev()) {
    return development
  }
  if (isTesting()) {
    return testing
  }
  if (isStaging()) {
    return staging
  }
  if (isProduction()) {
    return production
  }
  if (isEuProd()) {
    return euProduction
  }
  return development
})()
